<template>
  <div
    v-click-outside="hideEraSelector"
    :class="{
      'cursor-pointer': editable,
    }"
    class="text-md flex flex-row items-center relative"
    @click="toggleEraSelector"
  >
    <div
      :class="{
        'hover:bg-gray-200 px-1.5 duration-300 transition rounded-lg': editable,
        'bg-gray-200': dropdownVisibility
      }"
      class="flex-grow py-2 leading-none select-none"
    >
      <span class="mr-2">
        {{ currentEra }}
      </span>
      <i
        v-if="editable"
        :class="{
          'fa-caret-down': !dropdownVisibility,
          'fa-caret-up': dropdownVisibility
        }"
        class="fas cursor-pointer"
      />
    </div>
    <div
      v-if="dropdownVisibility"
      class="absolute left-0 flex flex-col top-8 bg-white z-50 rounded-lg w-full border border-roc-blue"
    >
      <div class="max-h-48 overflow-y-auto">
        <div
          v-for="item in eraList"
          :key="item.id"
          class="p-2 text-black text-md flex flex-row items-center group cursor-pointer leading-none hover:bg-gray-100 duration-300 transition gap-2"
          @click="changeEra(item.id)"
        >
          <i
            :class="{
              'text-white': item.id !== buildingEra,
              'text-black': item.id === buildingEra
            }"
            class="fas fa-check"
          />
          <span>
            {{ item.title }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Eras from '@/roc/era';
import {computed, ref} from 'vue';
import {useApplicationStore} from '@/roc/stores/ApplicationStore';

export default {
  props: {
    buildingEra: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    const appStore = useApplicationStore();

    const dropdownVisibility = ref(false);

    return {
      dropdownVisibility,

      currentEra: computed(() => {
        return Eras[props.buildingEra].name;
      }),
      eraList: computed(() => {
        const keys = Object.keys(Eras);
        const myEra = keys.indexOf(appStore.selectedEra);
        const result = [];
        for (const i in Eras) {
          if (i !== 'stoneAge') {
            const thisEra = keys.indexOf(i);
            if (thisEra <= myEra) {
              result.push({
                id: i,
                title: Eras[i].name
              });
            }
          }
        }
        return result;
      }),
      editable: computed(() => {
        return appStore.editable;
      }),

      toggleEraSelector() {
        if (appStore.editable) {
          dropdownVisibility.value = !dropdownVisibility.value;
        }
      },
      hideEraSelector() {
        dropdownVisibility.value = false;
      },
      changeEra(newEra) {
        context.emit('changeEra', newEra);
      }
    };
  }
};
</script>
